import { JVInput } from "../../shared/JVInput";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { ICityMastDropdown, IClientCompanyDropdown, IStateMastDropdown, IVisaDropdown } from "../../models/IDropdown";
import { emptyFilter } from "./Table";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { useEffect, useState } from "react";
import { JVDate } from "../../shared/JVDate";
import { JVMultiselect } from "../../shared/JVMultiselect";
import { MultiSelect } from "primereact/multiselect";

interface IProps {
    filters: IFilterResume,
    setFilters: (filters: IFilterResume) => void,
    toast: any,
    setSelectedAvailability: (item: string[]) => void,
    setSelectedSource: (item: number[]) => void,
    setSelectedVisa: (item: number[]) => void,
    setSelectedLocation: (item: number[]) => void,
    setSelectedPreffered: (item: number[]) => void,
    setSelectedExp: (item: number[]) => void,
    selectedAvailability: string[],
    selectedSource: number[],
    selectedVisa: number[],
    selectedLocation: number[],
    selectedPreffered: number[],
    selectedExp: number[],
}

interface ISourceDropdown {
    sourceId: number;
    source_Name: string;
}

export interface IFilterResume {
    query?: string | null,
    email?: string | null,
    job_Title?: string | null,
    source?: number[] | null,
    rate?: number | null,
    salary?: number | null,
    stateL?: number[] | null,
    stateP?: number[] | null,
    consultant_ID?: number | null,
    home_No?: string | null,
    cell_No?: string | null,
    relocation?: boolean | null,
    total_Experience?: number[] | null,
    availability?: string[] | null,
    fromDate?: Date | null,
    toDate?: Date | null,
    vendor_Company_ID?: number | null,
    visa_ID?: number[] | null,
    added?: number | null,
    edited?: number | null,
    submited?: number | null,
    blocked?: number | null,
    deleted?: string | null,
    consID?: number | null,
    phone?: string | null,
    cell?: string | null,
    companyName?: IClientCompanyDropdown | null,
    contactPersonEmail?: string | null,
}

const schema = yup.object({
    query: yup.string().required("Query is required"),
    email: yup.string().nullable(),
    job_Title: yup.string().nullable(),
    // source: yup.string().nullable(),
    rate: yup.number().nullable(),
    salary: yup.number().nullable(),
    // stateL: yup.number().nullable(),
    // stateP: yup.number().nullable(),
    consultant_ID: yup.number().nullable(),
    home_No: yup.string().nullable(),
    cell_No: yup.string().nullable(),
    relocation: yup.boolean().nullable(),
    total_Experience: yup.number().nullable(),
    // availability: yup.string().nullable(),
    fromDate: yup.date().nullable(),
    toDate: yup.date().nullable(),
    vendor_Company_ID: yup.number().nullable(),
    // visa_ID: yup.number().nullable(),
    added: yup.number().nullable(),
    edited: yup.number().nullable(),
    submited: yup.number().nullable(),
    blocked: yup.number().nullable(),
    deleted: yup.string().nullable(),
    consID: yup.number().nullable(),
    phone: yup.string().nullable(),
    cell: yup.string().nullable(),
    companyName: yup.object().shape({
        vendor_Company_ID: yup.number().nullable(),
        vendor_Company_Name: yup.string().nullable()
    }).nullable(),
    contactPersonEmail: yup.string().nullable(),
});

export const Filter = (props: IProps) => {
    const [visa, setVisa] = useState<Array<IVisaDropdown>>([]);
    const [locationL, setLocationL] = useState<Array<IStateMastDropdown>>([]);
    const [locationP, setLocationP] = useState<Array<IStateMastDropdown>>([]);
    const [cities, setCities] = useState<Array<ICityMastDropdown>>([]);
    const [source, setSource] = useState<Array<ISourceDropdown>>([]);
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IFilterResume>({
        resolver: yupResolver(schema),
        defaultValues: props.filters,
        shouldFocusError: false
    });

    const loadVisa = async () => {
        const response = await Fetch("Dropdown/visa", "GET", null, null, null);
        if (response) {
            const data: Array<IVisaDropdown> = await response.json();
            // const emptyData = {
            //     visaId: 0,
            //     visa_Name: "-- SELECT --"
            // };
            // data.unshift(emptyData);
            setVisa(data);
        }
    }

    const loadStatesL = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `count=${true}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            // const emptyData = {
            //     state_ID: 0,
            //     state_Name: "-- SELECT --"
            // };
            // data.unshift(emptyData);
            setLocationL(data);
        }
    }

    const loadStatesP = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `count=${true}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            // const emptyData = {
            //     state_ID: 0,
            //     state_Name: "-- SELECT --"
            // };
            // data.unshift(emptyData);
            setLocationP(data);
        }
    }

    const completeMethodStatesL = (event: { query: string }) => {
        loadStatesL(event.query);
    }

    const completeMethodStatesP = (event: { query: string }) => {
        loadStatesP(event.query);
    }

    // const loadCities = async (filter: string | null) => {
    //     const state_ID = control._getWatch("State.state_ID");
    //     if (state_ID) {
    //         const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${state_ID}`, null);
    //         if (response) {
    //             const data: Array<ICityMastDropdown> = await response.json();
    //             setCities(data);
    //         }
    //     } else {
    //         props.toast.current.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
    //     }
    // }

    // const completeMethodCities = (event: { query: string }) => {
    //     loadCities(event.query);
    // }

    const loadSource = async () => {
        const response = await Fetch("Dropdown/source", "GET", null, null, null);
        if (response) {
            const data: Array<ISourceDropdown> = await response.json();
            // const emptyData = {
            //     sourceId: 0,
            //     source_Name: "-- SELECT --"
            // };
            // data.unshift(emptyData);
            setSource(data);
        }
    }

    // const searchResumes = async (query: string) => {
    //     props.setFilters({ query: query });
    // };

    const onSubmit = (data: IFilterResume) => {
        let filterData: IFilterResume = data;
        if (props.selectedSource.length > 0) filterData.source = props.selectedSource;
        if (props.selectedLocation.length > 0) filterData.stateL = props.selectedLocation;
        if (props.selectedPreffered.length > 0) filterData.stateP = props.selectedPreffered;
        if (props.selectedExp.length > 0) filterData.total_Experience = props.selectedExp;
        if (props.selectedAvailability.length > 0) filterData.availability = props.selectedAvailability;
        if (props.selectedVisa.length > 0) filterData.visa_ID = props.selectedVisa;

        props.setFilters(filterData);
    };

    const availability = [
        // { label: "-- SELECT --", value: "" },
        { label: "Immediate", value: "Immediate" },
        { label: "1 Week", value: "1 Week" },
        { label: "2 Week", value: "2 Week" },
        { label: "1 Month", value: "1 Month" },
        { label: "2 Month", value: "2 Month" },
        { label: "3 Month", value: "3 Month" },
    ];

    const relocation = [
        { label: "-- SELECT --", value: null },
        { label: "Yes", value: 1 },
        { label: "No", value: 0 },
    ];

    const experience = [
        // { label: "-- SELECT --", value: 0 },
        { label: "1", value: 1 },
        { label: "2", value: 2 },
        { label: "3", value: 3 },
        { label: "4", value: 4 },
        { label: "5", value: 5 },
        { label: "6", value: 6 },
        { label: "7", value: 7 },
        { label: "8", value: 8 },
        { label: "9", value: 9 },
        { label: "10", value: 10 },
        { label: "11", value: 11 },
        { label: "12", value: 12 },
        { label: "13", value: 13 },
        { label: "14", value: 14 },
        { label: "15", value: 15 },
        { label: "16", value: 16 },
        { label: "17", value: 17 },
        { label: "18", value: 18 },
        { label: "19", value: 19 },
        { label: "20", value: 20 }
    ];

    const onClear = () => {
        reset(emptyFilter);
        props.setSelectedAvailability([]);
        props.setSelectedSource([]);
        props.setSelectedVisa([]);
        props.setSelectedLocation([]);
        props.setSelectedPreffered([]);
        props.setSelectedExp([]);
    }

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies_emp_details", "GET", null, `filter=${encodeURIComponent(JSON.stringify(filter))}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }
    const completeMethodEC = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }

    useEffect(() => {
        loadSource();
        loadVisa();
        loadStatesL(null);
        loadStatesP(null);
    }, []);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid" >
                {/* <JVInput type="string" column={12} label="Search Resumes For" control={control} name="query" error={errors.query?.message} />
                <div className="col-12 md:col-12 flex">
                    <Button className="h-2rem w-6" label="SEARCH" type="submit"></Button>
                    <Button className="p-button-outlined h-2rem w-6 ml-3" label="CLEAR" onClick={() => { reset({query: ""}); }} type="button"></Button>
                </div> */}
                <h4 className="ml-3">Search Consultant</h4>
                <div style={{ border: "1px solid #2196F3", marginLeft: "1rem", marginRight: "1rem", width: "100%", marginTop: "-10px", height: "0px" }}></div>
                <div className="field col-12 md:col-12" style={{ display: 'flex', gap: '10px' }}></div>
                <JVInput required type="string" column={1} label="Search Resumes For" control={control} name="query" error={errors.query?.message} />
                {/* <div style={{ width: "100%" }} className="flex justify-content-end align-content-center pr-3">
                    <Button className="w-4" label='Search' style={{ height: '40px', width: '80px', marginTop: "20px" }} />
                </div> */}

                <div className="field col-12 md:col-12" style={{ display: 'flex', gap: '10px' }}></div>
                {/* <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" /> */}
                {/* <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" /> */}
                <JVInput column={6} label="Job Titles:" control={control} name="job_Title" />
                <JVInput column={6} label="Rate:" control={control} name="rate" />
                <JVInput column={6} label="Salary:" control={control} name="salary" />
                <div className="field col-12 md:col-2">
                    <p>Availability:</p>
                    <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={props.selectedAvailability} disabled={false} onChange={(e) => props.setSelectedAvailability(e.value)} options={availability} optionValue="value" optionLabel="label" display="chip" filter placeholder="Select Availability" />
                </div>
                <JVDropdown column={6} label="Relocation:" control={control} name="relocation" options={relocation} optionValue='value' optionLabel='label' placeholder="Select Relocation" />
                <div className="field col-12 md:col-2">
                    <p>Source:</p>
                    <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={props.selectedSource} disabled={false} onChange={(e) => props.setSelectedSource(e.value)} options={source} optionValue="sourceId" optionLabel="source_Name" display="chip" filter placeholder="Select Source" />
                </div>
                <div className="field col-12 md:col-2">
                    <p>Visa:</p>
                    <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={props.selectedVisa} disabled={false} onChange={(e) => props.setSelectedVisa(e.value)} options={visa} optionValue="visaId" optionLabel="visa_Name" display="chip" filter placeholder="Select Visa" />
                </div>
                <div className="field col-12 md:col-2">
                    <p>Location:</p>
                    <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={props.selectedLocation} disabled={false} onChange={(e) => props.setSelectedLocation(e.value)} options={locationL} optionValue="state_ID" optionLabel="state_Name" display="chip" filter placeholder="Select State" />
                </div>
                <div className="field col-12 md:col-2">
                    <p>Preffered Location:</p>
                    <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={props.selectedPreffered} disabled={false} onChange={(e) => props.setSelectedPreffered(e.value)} options={locationL} optionValue="state_ID" optionLabel="state_Name" display="chip" filter placeholder="Select State" />
                </div>
                <div className="field col-12 md:col-2">
                    <p>Experience:</p>
                    <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={props.selectedExp} disabled={false} onChange={(e) => props.setSelectedExp(e.value)} options={experience} optionValue="value" optionLabel="label" display="chip" filter placeholder="Select Experience" />
                </div>

                <div className="field col-12 md:col-12" style={{ display: 'flex', gap: '10px' }}></div>
                <h4 className="ml-3">Day back Search</h4>
                <div style={{ border: "1px solid #2196F3", marginLeft: "1rem", marginRight: "1rem", width: "100%", marginTop: "-10px", height: "0px" }}></div>
                <div className="field col-12 md:col-12" style={{ display: 'flex', gap: '10px' }}></div>
                <JVInput column={6} label="Added:" control={control} name="added" />
                <JVInput column={6} label="Edited:" control={control} name="edited" />
                <JVInput column={6} label="Submited:" control={control} name="submited" />
                <JVInput column={6} label="Blocked:" control={control} name="blocked" />
                <JVInput column={6} label="Deleted:" control={control} name="deleted" />

                <div className="field col-12 md:col-12" style={{ display: 'flex', gap: '10px' }}></div>
                <h4 className="ml-3">Other Information</h4>
                <div style={{ border: "1px solid #2196F3", marginLeft: "1rem", marginRight: "1rem", width: "100%", marginTop: "-10px", height: "0px" }}></div>
                <div className="field col-12 md:col-12" style={{ display: 'flex', gap: '10px' }}></div>
                <JVInput column={6} label="Consultant Email:" control={control} name="email" />
                <JVInput column={6} label="Cons.ID:" control={control} name="consID" />
                <JVInput column={6} label="Phone No:" control={control} name="phone" />
                <JVInput column={6} label="Cell No:" control={control} name="cell" />
                {/* <JVInput column={6} label="Company Name:" control={control} name="companyName" /> */}
                <JVDropdownInput required label="Company Name:" disabled={false} column={6} completeMethod={completeMethodEC} control={control} name="companyName" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Company" />
                <JVInput column={6} label="Contact Person Email:" control={control} name="contactPersonEmail" />
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={onClear} type="button"></Button>
                </div>
            </form>
        </>
    );
}